import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { mergeMap, catchError, take } from 'rxjs/operators';
import { CognitoService } from './cognito.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private URL_EXCLUDE_AUTH_LIST: string[] = ['s3.amazonaws.com', 'mock.pstmn.io'];

  constructor(
    private cognitoService: CognitoService,
    private router: Router
  ) {}

  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    req: HttpRequest<any>,
    next: HttpHandler
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    return this.cognitoService.getSession().pipe(
      take(1),
      mergeMap(session => {
        if (session && session.isValid() && this.isDriftAuthUrlPath(req.url)) {
          const jwtToken = session.getIdToken().getJwtToken();
          const clonedReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${jwtToken}`
            }
          });
          return next.handle(clonedReq);
        } else {
          return next.handle(req);
        }
      }),
      catchError(error => {
        if (error.status === 401 || error.status === 403) {
          // TODO: figure out how to handle this better
          this.router.navigate(['/home']);
        }
        return throwError(error);
      })
    );
  }

  private isDriftAuthUrlPath(url: string): boolean {
    return !this.URL_EXCLUDE_AUTH_LIST.some(item => url.includes(item));
  }
}
